import React, { Component } from 'react';
import LoaderWrapper from '../../../Components-2025/QuestionBank/LoaderWrapper';
import ReportCard from '../../../Components-2025/QuestionBank/ReportCard';
import VideoPlayListView from '../../../Components-2025/Videos/VideoPlayList';
import VideoValidateReportsIcons from '../../../Components-2025/Videos/VideoValidateReportsIcons';
import ComponentHeader from '../../../common/ComponentHeader';
import { REDIRECTION_ROUTES, SUBSCRIPTION_TYPES } from '../../../common/constant';
import { messages } from '../../../common/messages';
import { showInformation } from '../../../common/toast';
import FlashCard from '../../../components/FlashCard';
import ModalComponent from '../../Common/Modal';
import config from '../../config/AppRoutes';
import { nextAwareRoute, isNextPath } from '../../../common/cfa2NextRoutes';
import apiServiceProvider from './ApiService';
import { removeSuffix, generateDynamicRoute } from '../../../common/function';
let videoTableKey = 'cfa1_2025_videos';
export default class VideoPlayList extends Component {
  static contextTypes = { router: React.PropTypes.object };
  constructor(props) {
    super(props);
    this.state = {
      videoData: [],
      currentIndex: 0,
      title: '',
      isLoading: true,
      isFlashCardVisible: true,
      isReportSectionVisible: false,
      isPremiumPopupVisible: false,
      isUserPremium: false,
      examNameKey: '',
    };
    this.childRef = null;
    this.setChildRef = (element) => {
      this.childRef = element;
    };
  }
  async componentDidMount() {
    this.setState({ isLoading: true });
    const { chapterId, id } = this.props.params;
    const { mockId, caseId, pathwayId } = this.props.location.query;
    await this.getChapterWiseVideos({ chapterId, id, mockId, caseId, pathwayId });
  }

  getChapterWiseVideos = async (payload) => {
    const {
      success,
      associatedVideosTable,
      data,
      titleName,
      associatedSubscriptionKey,
      selectedExamSubscriptionDetails,
      examName,
    } = await apiServiceProvider['retrieveVideos'](payload);
    if (success) {
      videoTableKey = associatedVideosTable;
      const videosData = data[0][videoTableKey];
      const { id } = payload;
      let currentIndex = videosData.findIndex((item) => item.id === parseInt(id, 10));
      currentIndex = currentIndex === -1 ? 0 : currentIndex;

      //* HERE ADDED A CHECK IF USER WANT TO ACCESS PREMIUM VIDEO WITHOUT SUBSCRIPTION */
      const subscriptionDetail = selectedExamSubscriptionDetails[associatedSubscriptionKey];
      const isUserPremium =
        subscriptionDetail &&
        (subscriptionDetail.videoStatus ||
          subscriptionDetail.package_val === SUBSCRIPTION_TYPES.EXPENSIVE);

      if (isUserPremium || videosData[currentIndex].free) {
        this.setState({
          isLoading: false,
          examNameKey: examName,
          currentIndex: currentIndex > -1 ? currentIndex : 0,
          videoData: data.length && data[0][videoTableKey],
          title: data.length && (titleName || data[0]['chapter_name']),
          isUserPremium,
        });
        // CFA2 dated trees: opening a video URL directly (e.g. from the chapter list) must also count
        // as "last viewed" — previously only in-playlist clicks saved it, so "Go to my last viewed
        // video" pointed at a stale video. Scoped to /cfa2/2026|2027 so CFA3's shared /videos is unchanged.
        if (isNextPath() && videosData[currentIndex]) {
          await apiServiceProvider['saveLastViewedVideo']({
            videoId: videosData[currentIndex].id,
            videoIndex: currentIndex,
          });
        }
      } else {
        const { router } = this.context;
        router.push({ pathname: nextAwareRoute(config.VIDEOS) });
        showInformation(messages.PLEASE_SUBSCRIBE_TO_ACCESS_THIS_VIDEO);
      }
    } else {
      this.setState({ isLoading: false });
    }
  };

  navigateToVideo = async (index) => {
    const { state } = this;
    const { isUserPremium, videoData } = state;
    if (isUserPremium || videoData[index].free) {
      this.setState({ currentIndex: index });
      const { router } = this.context;
      router.push({
        pathname: nextAwareRoute(config.VIDEOS_LIST).replace(':id', videoData[index].id)
          .replace(':chapterId', videoData[index]['chapter_id']),
        query: {
          ...(videoData[index].mock_id && { mockId: videoData[index].mock_id }),
          ...(videoData[index].case_id && { caseId: videoData[index].case_id }),
          ...(videoData[index].pathway_id && { pathwayId: videoData[index].pathway_id }),
        },
      });
      await apiServiceProvider['saveLastViewedVideo']({
        videoId: videoData[index].id,
        videoIndex: index,
      });
    } else {
      this.setState({ isPremiumPopupVisible: true });
    }
  };

  redirectToSubscription = () => {
    const { router } = this.context;
    router.push({ pathname: '/Subscribe' });
  };

  handleShowPremiumModal = () => {
    this.setState({ isPremiumPopupVisible: !this.state.isPremiumPopupVisible });
  };

  onSaveItemChange = (status) => {
    this.setState({ isFlashCardVisible: status });
  };

  toggleReportSection = () =>
    this.setState((prevState) => ({ isReportSectionVisible: !prevState.isReportSectionVisible }));

  onHandleHideReportSection = () => {
    this.setState({ isReportSectionVisible: false });
  };

  render() {
    const {
      context: { router },
      props,
      state: {
        videoData,
        isLoading,
        currentIndex,
        isUserPremium,
        isPremiumPopupVisible,
        isFlashCardVisible,
        isReportSectionVisible,
        title,
        examNameKey,
      },
    } = this;
    const { mockId, caseId, pathwayId } = props.location.query;
    const isRedirectIconVisible = !mockId && !caseId && !pathwayId;
    const { notes = '', question = '' } = REDIRECTION_ROUTES[examNameKey] || {};
    const currentVideoData = videoData[currentIndex] || {};
    const titleName = caseId ? removeSuffix(title, '– volume') : title;

    const getRedirectRoute = (type, videoData, title) =>
      (type && generateDynamicRoute(type, videoData, title)) || '';

    return (
      <div className='animated fadeIn'>
        <LoaderWrapper isLoading={isLoading}>
          <div>
            <ComponentHeader title={titleName}>
              <button
                className='btn btn-primary pointer_class'
                onClick={() => router.push({ pathname: nextAwareRoute(config.VIDEOS) })}
              >
                {messages.BACK_TO_VIDEOS}
              </button>
            </ComponentHeader>
            <VideoPlayListView
              videoTitle={videoData[currentIndex] ? videoData[currentIndex]['title'] : ''}
              currentIndex={currentIndex}
              videosData={videoData}
              youtubeID={videoData[currentIndex] ? videoData[currentIndex]['url_id'] : ''}
              navigateToVideoByID={this.navigateToVideo}
              toggleAlert={this.handleShowPremiumModal}
              isUserSubscribed={isUserPremium}
            />
            <br /> <br />
            <VideoValidateReportsIcons
              isMoveToNotesIcon={isRedirectIconVisible}
              isMoveToQuestionIcon={isRedirectIconVisible}
              toggleAlert={this.handleShowPremiumModal}
              setChildRef={this.childRef}
              currentVideo={videoData[currentIndex] && videoData[currentIndex]}
              apiServiceProvider={apiServiceProvider}
              onSaveItemChange={this.onSaveItemChange}
              toggleReportSection={this.toggleReportSection}
              isUserSubscribed={isUserPremium}
              savePayLoad={{ videoId: videoData[currentIndex] && videoData[currentIndex].id }}
              favItemId={videoData[currentIndex] && videoData[currentIndex].id}
              notesRedirectRoute={getRedirectRoute(notes, currentVideoData, title)}
              questionRedirectRoute={getRedirectRoute(question, currentVideoData, title)}
            />
            <FlashCard
              item={{ id: videoData[currentIndex] ? videoData[currentIndex].id : '' }}
              type='video'
              isFlashCardHidden={isFlashCardVisible}
              ref={this.setChildRef}
            />
            {isReportSectionVisible && (
              <ReportCard
                section='video'
                hideReportSection={this.onHandleHideReportSection}
                apiServiceProvider={apiServiceProvider}
                itemId={videoData[currentIndex] ? videoData[currentIndex].id : ''}
                keyId='videoId'
              />
            )}
          </div>
        </LoaderWrapper>
        <ModalComponent
          goPremium={this.redirectToSubscription}
          toggleAlert={this.handleShowPremiumModal}
          alert_status={isPremiumPopupVisible}
          MessageContent={messages.CFA1_2025_PREMIUM_POPUP}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Videos/PlayList/index.jsx